import { render, staticRenderFns } from "./PossessedAttestationContentItem.vue?vue&type=template&id=3051e50e&scoped=true&"
import script from "./PossessedAttestationContentItem.vue?vue&type=script&lang=js&"
export * from "./PossessedAttestationContentItem.vue?vue&type=script&lang=js&"
import style0 from "./PossessedAttestationContentItem.vue?vue&type=style&index=0&id=3051e50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051e50e",
  null
  
)

export default component.exports